import { Card } from 'components/Card'
import { Heading } from 'components/Heading'
import { Input } from 'components/Input'
import { Button } from 'components/Button'
import { Link } from 'components/Link'
import { resetPassword } from 'api/auth'
import { getError, displayErrors } from 'validators/utils'
import logo from 'assets/images/tobook-logo.png'

export const ResetPassword = ({ attrs: { code } }) => {
  let errors = []
  let serverErrors
  let loading
  let success = false
  const formData = {
    resetCode: code,
    usernameOrEmail: '',
    password: ''
  }
  const triggerPasswordReset = () => {
    errors = []
    loading = true
    resetPassword(formData)
      .then(res => {
        loading = false
        success = true
      })
      .catch(err => {
        loading = false
        serverErrors = err.response.Errors
      })
  }
  return {
    view () {
      return m('.h-full.flex.flex-col.justify-center.items-center.bg-orange-500.h-screen',
        [
          m('img.my-10.w-64', { src: logo }),
          m(Card, {
            classes: ['w-4/5', 'max-w-md']
          }, [
            m('.p-6', [
              m(Heading, t('forgottenPassword', 'title')),
              success ? m('div', [
                m('p', 'Password reset. Please login.'),
                m(Button, {
                  type: 'button',
                  onclick () {
                    m.route.set('/login')
                  }
                }, 'Login')
              ]) : m('form.grid.gap-6', {
                onsubmit (e) {
                  e.preventDefault()
                  triggerPasswordReset()
                }
              }, [
                m(Input, {
                  label: t('forgottenPassword', 'email'),
                  value: formData.usernameOrEmail,
                  type: 'email',
                  required: true,
                  errorMessage: getError(errors, 'email'),
                  oninput (val) {
                    formData.usernameOrEmail = val
                  }
                }),
                m(Input, {
                  label: 'New ' + t('register', 'password'),
                  value: formData.password,
                  type: 'password',
                  required: true,
                  errorMessage: getError(errors, 'password'),
                  oninput (val) {
                    formData.password = val
                  }
                }),
                displayErrors(serverErrors),
                m('.flex.justify-between.items-center', [
                  m(Link, {
                    classes: ['text-orange-900', 'underline'],
                    href: '/login'
                  }, t('forgottenPassword', 'logInLink')),
                  m(Button, {
                    variant: 'positive',
                    loading
                  }, t('forgottenPassword', 'resetAction'))
                ])
              ])
            ])
          ])
        ])
    }
  }
}
